import React from 'react';
import partial from 'lodash/partial';
import DropdownMenu from 'common/components/dropdown_menu';

const NegotiationActions = ({ actions, selectedCreative, onClick }) => {
  const dropdownBtns = actions.map(a => {
    return {
      label: a.label,
      show: true,
      disabled: a.requiresNewCreative && !selectedCreative,
      action: partial(onClick, a),
      extraBtnClasses: "btn btn-primary"
    };
  })

  return (
    <DropdownMenu buttons={dropdownBtns} className="with-buttons" showFirst={true}/>
  );
}

export default NegotiationActions;



// WEBPACK FOOTER //
// ./project/components/brief/negotiation_actions_1_1.jsx